var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretDown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.29292 19.2929L15.2929 9.29292C15.3858 9.19994 15.4961 9.12618 15.6175 9.07586C15.7389 9.02554 15.869 8.99963 16.0004 8.99963C16.1318 8.99963 16.262 9.02554 16.3834 9.07586C16.5048 9.12618 16.615 9.19994 16.7079 9.29292L26.7079 19.2929C26.8956 19.4806 27.001 19.7351 27.001 20.0004C27.001 20.2658 26.8956 20.5203 26.7079 20.7079C26.5203 20.8956 26.2658 21.001 26.0004 21.001C25.7351 21.001 25.4806 20.8956 25.2929 20.7079L16.0004 11.4142L6.70792 20.7079C6.61501 20.8008 6.50471 20.8745 6.38332 20.9248C6.26192 20.9751 6.13181 21.001 6.00042 21.001C5.86902 21.001 5.73892 20.9751 5.61752 20.9248C5.49613 20.8745 5.38583 20.8008 5.29292 20.7079C5.20001 20.615 5.12631 20.5047 5.07603 20.3833C5.02574 20.2619 4.99986 20.1318 4.99986 20.0004C4.99986 19.869 5.02574 19.7389 5.07603 19.6175C5.12631 19.4961 5.20001 19.3858 5.29292 19.2929Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/ArrowUp.661299086e71287a8cafd945161fece9.svg";
export { ForwardRef as ReactComponent };